export default class Distributor {
  static generateEmpty() {
    return {
      name: '',
      email: '',
      address: '',
      // Structured address -- the DecoNetwork shipping.ship_from source.
      address_line1: '',
      address_line2: '',
      address_city: '',
      address_state: '',
      address_postal_code: '',
      address_country: 'US',
      address_phone: '',
      // ow_cost / campaign_cost / transaction_cost removed in pebble 7
      // (pricing_engine_006).
      max_sales_count: 10,
      accounts: [],
      campaigns: [],
      products: [],
      _jv: {
        type: 'Distributor',
      }
    };
  };
}